export default __webpack_public_path__ + "static/media/Likes.4343c6c4.svg";